angular.module('tf.directives')

    .directive('regexInputFilter', function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        scope :{
            filter :"@regexInputFilter"
        },
        link: function (scope, element, attr, ngModelCtrl) {

            var regex = new RegExp(scope.filter, 'gi');

            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(regex, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});